export default __webpack_public_path__ + "images/map-pin.png?a9a6a092ff9ed13f36f9e96eb4eb4ebc";